import { render } from "./NewBoatPage.vue?vue&type=template&id=33b33520"
import script from "./NewBoatPage.vue?vue&type=script&lang=js"
export * from "./NewBoatPage.vue?vue&type=script&lang=js"

import "./NewBoatPage.vue?vue&type=style&index=0&id=33b33520&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__